module.exports = __webpack_public_path__ + "img/xlsx_type.81380008.jpg";